export const CREATE_CONTACT_LOADING = 'create_contact_loading';
export const CREATE_CONTACT_SUCCESS = 'create_contact_success';
export const CREATE_CONTACT_ERROR = 'create_contact_error';
export const UPDATE_CONTACT_SUCCESS = 'update_contact_success';
export const UPDATE_CONTACT_ERROR = 'update_contact_error';
export const GET_CONTACT_SUCCESS = 'get_contact_success';
export const GET_CONTACT_ERROR = 'get_contact_error';